import styled, { css } from 'styled-components';

export const MobileScrollWrapper = styled.div`
  @media (${p => p.theme.mq.mobile}) {
    position: fixed;
    top: ${p => (p.makeSpaceForNotificationBar ? '79px' : '59px')};
    left: 0;
    width: 100vw;
    overflow: scroll;
    height: 170px;
    background-color: white;
    z-index: 99999;
    box-shadow: ${p => p.theme.boxShadow2};
    -webkit-overflow-scrolling: touch;

    ${p =>
      !p.show &&
      css`
        display: none;
      `};
  }
`;

export const StepperWrapper = styled.div`
  font-size: 13px;
  padding: 10px;
  min-width: 800px;
  display: block;
  padding: ${p => p.theme.base.spacing.huge};
  margin-bottom: ${p => p.theme.spacing(4)};
`;

export const StepperList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const StepperListItem = styled.li`
  align-items: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;
  transition: all 0.1s;

  &:first-of-type {
    align-items: flex-start;
    flex: 0.5 1;
  }

  &:last-of-type {
    align-items: flex-end;
    flex: 0.5 1;
  }

  &:nth-of-type(n + 2):before,
  &:nth-last-of-type(2):after {
    border-top: 3px solid ${p => p.theme.color.gray};
    content: '';
    display: block;
    position: absolute;
    right: calc(50% + 18px);
    top: 60px;
    width: calc(100% - 36px);
    z-index: 2;
  }

  &:nth-of-type(2):before {
    width: calc(100% - 48px);
  }

  &:nth-last-of-type(2):after {
    left: calc(50% + 18px);
    right: auto;
    width: calc(100% - 48px);
  }

  &:last-of-type:after {
    display: none;
  }

  ${p =>
    p.status === 'DONE' &&
    css`
      &:after,
      &:before {
        border-top-color: ${p.theme.color.teal} !important;
      }
    `};

  ${p =>
    p.status === 'CURRENT' &&
    css`
      &:before {
        border-top-color: ${p.theme.color.teal} !important;
      }
    `};
`;

export const StepperListTitle = styled.span`
  color: ${p => p.theme.color.graySemiDark};
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 0.5px;
  margin: 1px 0 0;
  text-transform: uppercase;
  margin: 0;
`;

export const StepperListIcon = styled.div`
  height: 32px;
  margin: 0  ${p => p.theme.spacing(2)} 0 0;
  width: 32px;

  @media (${p => p.theme.mq.desktop}) {
    margin: 0 0  ${p => p.theme.spacing(3)};
  }

  ${p =>
    p.status === 'CURRENT' &&
    css`
      animation: ${p.theme.pulse} 2s infinite;
      border: 2px solid ${p.theme.color.teal};
      border-radius: 50%;
      box-shadow: 0 0 0 ${p.theme.rgba('black', 0.4)};
      display: inline-block;
      height: 24px;
      width: 24px;

      &:hover {
        animation: none;
      }
    `}

  ${p =>
    p.status === 'DONE' &&
    css`
      background-color: ${p.theme.color.teal};
      border-radius: 50%;
      display: inline-block;
      height: 24px;
      width: 24px;
    `}

  ${p =>
    p.status === 'PENDING' &&
    css`
      background-color: ${p.theme.color.gray};
      border-radius: 50%;
      display: inline-block;
      height: 24px;
      width: 24px;
    `}
`;

export const StepperStatusListWrapper = styled.div`
  box-sizing: border-box;
  align-items: center;
  display: flex;
  position: relative;
  text-align: center;
  transition: all 0.1s;
  min-height: 34px;
  margin-bottom: 15px;

  @media (${p => p.theme.mq.desktop}) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const StepperStatusList = styled.div`
  height: 24px;
  width: 24px;
  background: url(${p => p.url});
  background-size: cover;
  border-radius: 50%;
  display: inline-block;
  margin: 0 2px 10px 2px;

  &:hover {
    transform: scale(2.5);
  }

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }

  ${p =>
    (p.status === 'CURRENT' || p.status === 'DONE') &&
    css`
      background-color: ${p.theme.color.teal};
    `};

  ${p =>
    p.status === 'PENDING' &&
    css`
      background-color: ${p.theme.color.gray};
    `};
`;



// WEBPACK FOOTER //
// ./src/components/Stepper/styles.js